import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var NavItem = function NavItem(_ref) {
  var title = _ref.title,
      href = _ref.href;
  var getClassName = getClassNameFactory("SiteFooterNavItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "link"
    }),
    href: href
  }, title));
};

NavItem.displayName = "SiteFooter.NavItem";
export default NavItem;